// hooks
import { useTranslation } from "react-i18next";

// components

// assets
import { offer } from "../../utils/cards-svgs";

const DiscountCode = () => {
    const [t] = useTranslation("global");
    return (
        <div className="discount-div product-section-div">
            <h5 className="discount-div-title cart-title">
                <img src={offer} alt="icon" /> {t("cart.discount")}
            </h5>
            <div className="discount-form">
                <input
                    type="text"
                    placeholder={t("cart.entr-discount")}
                    className="ocean-input"
                />
                <button className="ocean-btn discount-btn">
                    <div className="add-to-cart-svg"></div>
                    {t("cart.discount-btn")}
                </button>
            </div>
        </div>
    );
};

export default DiscountCode;
